<script lang="ts">
    import { getDashboardCtx } from "../state/dashboard.svelte";
    import SectionHeader from "../components/SectionHeader.svelte";
    import ReferralCodeCard from "./marketing/ReferralCodeCard.svelte";
    import CreativesCard from "./marketing/CreativesCard.svelte";
    import ProductsCard from "./marketing/ProductsCard.svelte";

    const store = getDashboardCtx();
</script>

<div class="dashStack">
    <SectionHeader id="marketing" />
    <div class="dashGrid2">
        <ReferralCodeCard />
        {#if store.isStripeConfigured}
            <div class="dashStack">
                <CreativesCard />
                <ProductsCard />
            </div>
        {/if}
    </div>
</div>
